// extracted by mini-css-extract-plugin
module.exports = {"container":"QuantitySelector-module__container___KA3QM","text":"QuantitySelector-module__text___3-Rm6","quantity_button":"QuantitySelector-module__quantity_button___1zaBL"};